import { type Market, marketPrefixPattern } from '@bridebook/toolbox/src/gazetteer';

/**
 * Articles are hosted on WordPress instance (54.78.135.105) and then copied to Bridebook.
 *
 * It is important for deep-links that internal links are relative with `_self` target.
 *
 * Processing includes:
 *  - make external links nofollow
 *  - make internal links relative (without domain, starting with /) - Wordpress IP links are also covered
 *  - prepend internal URL with market prefix if it doesn't yet have one
 */

/**
 * This pattern matches anything that resembles an IPv4 address.
 */
const anyIp = /[0-9]{1,3}(?:[.][0-9]{1,3}){3}/;

/**
 * This pattern matches bridebook.com and bridebook.co.uk domains.
 * The protocol is optional, as well as the `business` or `www` subdomains.
 */
const domain = /(?:https?:[/]{2})?(?:(?:business|www)[.])?bridebook[.]co(?:m|[.]uk)/;
const domainHref = new RegExp(`href="${domain.source.replace('business|', '')}`, 'gi');
const wordpressHref = new RegExp(
  `href="https?:[/]{2}${anyIp.source}([/]${marketPrefixPattern.source})?[/](?:article[/])?`,
  'gi',
);

const urlExternal = new RegExp(`<a\\s+href="(?!(?:[/]|${domain.source}))`, 'gi');
const urlInternal = new RegExp(`<a\\s+href="(?=(?:[/]|${domain.source}))`, 'gi');
const hrefWithoutLocale = new RegExp(`href="[/](?!(?:${marketPrefixPattern.source})["/])`, 'gi');

export const processArticleUrls = (input: string, isCordova: boolean, market: Market): string =>
  input
    .replace(domainHref, 'href="')
    .replace(wordpressHref, (_match, locale) => `href="${locale ?? ''}/article/`)
    .replace(urlExternal, '<a target="_blank" href="')
    .replace(urlInternal, `<a target="${isCordova ? '_self' : '_blank'}" href="`)
    .replace(hrefWithoutLocale, `href="/${market.prefix}/`);
